import { Dto } from '@mango/core';
import { Projectregel } from './projectregel';

@Dto({fullName: "CIJBorculo.Logic.CreatePakbon"})
export class createPakbon {
    projectregels?: Projectregel[];
}
